import { defineStore } from 'pinia'
import { NullOrType, OrderTracking, RequestTracking, Product } from '@/types'
import Logger from '@/services/log'
import Provider from '@/provider'
import Analytics from '@/services/analytics'
import { fillUpProductProperties } from '../product'
export interface OrderTrackingState {
  orderTracking: NullOrType<OrderTracking>
  requestTracking: RequestTracking
  error: any
  productsRecommendationTracking: NullOrType<Product[]>
}

const usePageStore = defineStore('tracking', {
  state: (): OrderTrackingState => ({
    orderTracking: null,
    requestTracking: { email: '', orderNumber: '' },
    error: null,
    productsRecommendationTracking: [],
  }),

  actions: {
    async getStatusOrderNumber({ email, orderNumber }: RequestTracking) {
      try {
        this.requestTracking = { email, orderNumber }

        const provider = await Provider.getInstance()
        const orderTracking = await provider.getStatusOrderNumber({
          email,
          orderNumber,
        })

        this.orderTracking = orderTracking
        return orderTracking
      } catch (error: any) {
        this.error = error
        Analytics.error(error)
        Logger.error('Error on get status order number', { error })
        throw error
      }
    },

    async getProductsRecommendationTrackingPage(payload: {
      ip: string
      email: string
      order: string
    }) {
      try {
        const provider = await Provider.getInstance()
        let productsRecommendationTracking =
          await provider.getProductsRecommendationTrackingPage(payload)

        productsRecommendationTracking = productsRecommendationTracking.map(
          (product) => {
            return fillUpProductProperties(product)!
          }
        )
        this.productsRecommendationTracking = productsRecommendationTracking
        return productsRecommendationTracking
      } catch (error: any) {
        this.error = error
        Analytics.error(error)
        Logger.error('Error on get products recommendation tracking', { error })
        throw error
      }
    },
  },
})

export default usePageStore
